import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useAppointmentModal } from '../context/AppointmentModalContext';
import Seo from './Seo';
import { breadcrumbJsonLd } from '../seo/structuredData';
import { useI18n } from '../i18n/I18nContext';
import './Leistungen.css';

function Vortraege() {
  const { openModal } = useAppointmentModal();
  const { lang, copy } = useI18n();

  return (
    <div className="leistungen-page">
      <Seo
        page="vortraege"
        jsonLd={breadcrumbJsonLd([
          { name: 'Home', path: lang === 'en' ? '/en' : '/' },
          { name: copy.speaking.crumb, path: lang === 'en' ? '/en/speaking' : '/vortraege' },
        ])}
      />
      <Header />

      <div className="leistungen-main-content">
        <section className="leistungen-service-section leistungen-vortrag-section">
          <div className="leistungen-service-layout">
            <div className="leistungen-service-image">
              <img
                src="/img/michaela_speaker.jpeg"
                alt={copy.speaking.alt}
                className="leistungen-image"
              />
            </div>

            <div className="leistungen-service-text">
              <div className="leistungen-service-header">
                <h1 className="leistungen-service-title mirror-ornament">{copy.speaking.label}</h1>
                <p className="leistungen-service-subtitle">{copy.speaking.title}</p>
              </div>

              <div className="leistungen-service-content">
                <p className="leistungen-service-description">
                  {copy.speaking.p1}
                </p>

                <p className="leistungen-service-description">
                  {copy.speaking.p2}
                </p>

                <p className="leistungen-vortrag-reference">
                  {copy.speaking.caption}
                </p>

                <button
                  type="button"
                  onClick={openModal}
                  className="leistungen-vortrag-cta"
                >
                  {copy.speaking.cta}
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer showContactForm={false} />
    </div>
  );
}

export default Vortraege;
